module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-toyota.12cc7fda.png";